import apiClient, { setAuthToken } from './api.client';

const request = async (method, url, accountId, options = {}) => {
  const token = localStorage.getItem('token');
  if (token) setAuthToken(token);
  try {
    const response = await apiClient.request({
      method,
      url,
      ...options,
      params: { ...options.params, accountId },
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      const unauthorized = new Error('Unauthorized');
      unauthorized.status = 401;
      throw unauthorized;
    }
    throw error;
  }
};

const InventoryService = {
  getOverview: (accountId) => request('get', '/inventory/overview', accountId),
  listItems: (accountId, params) => request('get', '/inventory/items', accountId, { params }),
  createItem: (accountId, data) => request('post', '/inventory/items', accountId, { data }),
  updateItem: (accountId, id, data) =>
    request('patch', `/inventory/items/${id}`, accountId, { data }),
  deleteItem: (accountId, id) =>
    request('delete', `/inventory/items/${id}`, accountId),
  createMovement: (accountId, itemId, data) =>
    request('post', `/inventory/items/${itemId}/movements`, accountId, { data }),
  listMovements: (accountId, params) =>
    request('get', '/inventory/movements', accountId, { params }),
  getRecipe: (accountId, menuItemId) =>
    request('get', `/inventory/recipes/menu-items/${menuItemId}`, accountId),
  updateRecipe: (accountId, menuItemId, data) =>
    request('put', `/inventory/recipes/menu-items/${menuItemId}`, accountId, { data }),
  updateSettings: (accountId, data) =>
    request('patch', '/inventory/settings', accountId, { data }),
};

export default InventoryService;
